// export const url = "https://mozakcrm.herokuapp.com/api/v1"
// export const url = "https://api.mozack.co/api/v1"
// export const url = "http://localhost:8000/api/v1"

// CRM Notifications URL ==============
export const socketbaseurl = "https://notifications.mozack.org";

// CRM BASE URL ============

export const baseurl = "https://api.mozack.org"
// export const baseurl = "https://crm-crm-api-server.i0necx.easypanel.host"
// export const baseurl = "https://test.mozack.co";
// export const baseurl = "https://testapi.zidham.com";
// export const baseurl = "http://localhost:8002"
// export const baseurl = "http://192.168.4.105:8000";

//SGI Base URL =============

export const sgibaseurl = "https://stripe.mozack.org";
// export const sgibaseurl = "http://localhost:8000";


// SUB URLS
export const url = `${baseurl}/api/v1`;
export const sgiurlv1 = `${sgibaseurl}/api/v1`;
export const sgiurl = `${sgibaseurl}/api/v2`;




export const OTPtimer = 600;
export const appBuildVersion = "1.0.9";

